import { render, staticRenderFns } from "./open_report.vue?vue&type=template&id=6bf53c8f&scoped=true"
import script from "./open_report.vue?vue&type=script&lang=js"
export * from "./open_report.vue?vue&type=script&lang=js"
import style0 from "./open_report.vue?vue&type=style&index=0&id=6bf53c8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf53c8f",
  null
  
)

export default component.exports